import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

import { CheckoutForgotPasswordFormComponent } from "./forgotPasswordForm.component";

type Props = {
    className?: string;
    notification: string;
};

const ForgotPasswordForm = ({ className, notification }: Props) => {
    const dispatch = useThunkDispatch();
    const { t } = useGranite();

    const { close: closeModal } = useModalRouter(ModalType.ForgotPassword);

    const onSubmit = (email: string) =>
        dispatch(CustomerModule.forgotPassword(email)).then((action) => {
            if (action.type === CustomerModule.APIStatus.SUCCESS) {
                closeModal();

                broadcastMessage({
                    id: "login",
                    text: t("account.forgotPassword.request.success"),
                    status: "success",
                    dismissible: true
                });
            }
        });

    return (
        <CheckoutForgotPasswordFormComponent
            className={className}
            notification={notification}
            onSubmit={onSubmit}
        />
    );
};

export { ForgotPasswordForm };
